import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import Modal from '@/assets/common/Modal/Modal.vue';
import { toCamel } from 'snake-camel';
import store from '@/assets/common/store/store';
import moment from 'moment';

type MappedDataStock = {
    chemical_id: string | number;
    chemical_name: string;
    amount: string | number;
    inner_capacity:  string | number;
    purchase_date: string;
    quantity:  string | number;
    unit_name:string;
    chemicalEmptyFlag: boolean;
    chemicalErrorFlag : boolean;
    chemicalNameErrorFlag : boolean;
    chemicalDateEmptyFlag : boolean;
    chemicalDateErrorFlag : boolean;
    chemicalCapacityErrorFlag : boolean;
    chemicalCapacityEmptyFlag: boolean;
    chemicalQuanityErrorFlag : boolean;
    chemicalQuanityEmptyFlag : boolean;
    chemicalAmountErrorFlag : boolean;
    chemicalAmountEmptyflag: boolean;
    chemicalWeightUnitErrorFlag : boolean;
    chemicalWeightUnitMismatchErrorFlag : boolean;
    chemicalIdNameMismatch :boolean;
    chemicalWeightUnitEmptyFlag: boolean;
    chemicalNameNoDataFlag:boolean;
    master_unit_name: string|null;
    chemicalQuanityDecimalFlag:boolean;
  }

  type ChemicalStocks = {
    display_name: string;
    id: number;
    unit_name: string;
  }

@Component({
    components: {
        Modal
    }
})
export default class ChemicalBulkInsertModal extends Vue {
    @Prop()
    private value!: boolean

    @Prop()
    private warehouseId!: string

    @Prop()
    private selectedWarehouseId!: string

    private csvData: string[][] = [];

    private unMatchedData: string[][] = [];

    private isSpinnerLoading = false;

    private isAlert = false;

    private modalTitle = '農薬一括登録'

    private selectedChemicals: ChemicalStocks[] = []

    get showChemicalBulkInsertModal(): boolean {
        return this.value
    }
    set showChemicalBulkInsertModal(b: boolean) {
        b
    }
    private mappedResult: MappedDataStock[] = [];

    private inputFlag = false;

    private unmatchedChemicalDetailsArray : { id: string | number; unit_name: string }[] = [];

    private matchedChemicalDetailsArray : { id: string | number; unit_name: string }[] = [];

    private chemicalUnits = [] as any[];

    get baseUrl(): string {
        return `/admin/warehouses/${this.warehouseId}/chemicals/stocks`
    }

    @Watch('value')
    onModalOpen(newVal: boolean): void {
        if (newVal) {
            this.getChemicalUnits();
        }
    }
     
    save(): boolean {
        if (!this.validation()) {
            return false
        }
        const data = { stocks: this.mappedResult, chemicals: this.unmatchedChemicalDetailsArray};
        if(data.stocks.length!=0){
            this.$apiClient.doRequest('put', this.baseUrl, data)
            .then(() => {
               this.$emit('save-success');
                this.$toasted.success('保存しました。')
            })
           this.isAlert = false
           this.clearSelectedFile();
           this.mappedResult = [];
        }else{
            this.$emit('save-success');
        }
        return true
    }

    private validation(): boolean {
        const errmsg: string[] = []
        if(this.mappedResult.length>0){
         this.mappedResult.forEach(stock=>{
            if(stock.chemicalIdNameMismatch){
                if (!errmsg.includes("登録番号と農薬名を確認してください")) {
                    errmsg.push("登録番号と農薬名を確認してください")
                }
            }
            if(stock.chemicalEmptyFlag){
                if (!errmsg.includes("登録番号を入力してください")) {
                    errmsg.push("登録番号を入力してください")
                }
            }
            if(stock.chemicalErrorFlag){
                if (!errmsg.includes("登録番号を確認してください")) {
                    errmsg.push("登録番号を確認してください")
                }
            }
            if(stock.chemicalDateErrorFlag){
                if (!errmsg.includes("購入日を確認してください")) {
                    errmsg.push("購入日を確認してください")
                }
            }
            if(stock.chemicalNameErrorFlag){
                if (!errmsg.includes("農薬名を入力してください")) {
                    errmsg.push("農薬名を入力してください")
                } 
            }
            if(stock.chemicalDateEmptyFlag){
                if (!errmsg.includes("購入日を入力してください")) {
                    errmsg.push("購入日を入力してください")
                }
            }
            if(stock.chemicalQuanityErrorFlag){
                if (!errmsg.includes("整数部7桁小の数値を入力してください")) {
                    errmsg.push("整数部7桁小の数値を入力してください")
                }
            }
            if(stock.chemicalQuanityEmptyFlag){
                if(!errmsg.includes("本数を入力してください")){
                    errmsg.push("本数を入力してください")
                }
            }
            if(stock.chemicalCapacityErrorFlag){
                if (!errmsg.includes("整数部7桁小数部2桁までの数値を入力してください")) {
                    errmsg.push("整数部7桁小数部2桁までの数値を入力してください")
                }
            }
            if(stock.chemicalCapacityEmptyFlag){
                if (!errmsg.includes("内容量を入力してください")) {
                    errmsg.push("内容量を入力してください")
                }
            }
            if(stock.chemicalAmountErrorFlag){
                if (!errmsg.includes("整数部7桁小の数値を入力してください")) {
                    errmsg.push("整数部7桁小の数値を入力してください")
                }
            }
            if(stock.chemicalAmountEmptyflag){
                if(!errmsg.includes("購入金額を入力してください")) {
                    errmsg.push("購入金額を入力してください")
                }
            }
            if(stock.chemicalWeightUnitErrorFlag){
                if (!errmsg.includes("単位が「kg,g,L,mL」を入力してください")) {
                    errmsg.push("単位が「kg,g,L,mL」を入力してください")
                }
            }
            if(stock.chemicalWeightUnitEmptyFlag){
                if (!errmsg.includes("単位を入力してください")) {
                    errmsg.push("単位を入力してください")
                }
            }
            if(stock.chemicalWeightUnitMismatchErrorFlag){
                if (!errmsg.includes(`既に登録さている単位は「${stock.master_unit_name}」です。異なる単位は登録できません。`)) {
                    errmsg.push(`既に登録さている単位は「${stock.master_unit_name}」です。異なる単位は登録できません。`)
                }
            }
            if(stock.chemicalQuanityDecimalFlag){
                if (!errmsg.includes("本数を確認してください")) {
                    errmsg.push("本数を確認してください")
                }
            }
         })
        }
        if (errmsg.length > 0) {
            window.alert(errmsg.join('\n'))
            return false
        }
        return true
    }

    @Emit('cancel')
    cancel(): void {
        if (this.inputFlag) {
            const result = window.confirm('変更内容を破棄します。よろしいですか。');
            if (result) {
                this.clearSelectedFile();
                this.mappedResult = [];
                this.$emit('input', false);
                this.$store.dispatch('doUpdateIsInputChanged', false);
                this.inputFlag = false;
            } else{
                return
            }
        }else {
                this.$emit('input', false);
            }
    }

    clearSelectedFile(){
        const fileInput = document.querySelector('.csv-upload-button') as HTMLInputElement | null;
        if (fileInput) {
            fileInput.value = '';
        }
    }

    downloadCSV() {
        const headers = ['登録番号','農薬名','購入日', '内容量','本数','単位','金額'];

        const csvContent = headers.join(',');

        const blob = new Blob([new Uint8Array([0xEF, 0xBB, 0xBF]), csvContent], { type: 'text/csv;charset=utf-8' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = '農薬一括登録（フォーマット）.csv';
        link.click();
    }

    uploadCSV(event: Event) {
        const input = event.target as HTMLInputElement;
        const file = input.files?.[0];

        if (file) {
          const reader = new FileReader();
          reader.onload = () => {
            const csvText = reader.result as string;
            this.parseCSV(csvText);
            input.value = '';
          };
          reader.readAsText(file,'Shift_JIS');
          this.inputFlag = true;
        }
    }

    parseCSV(csvText: string) {
        const rows = csvText.split('\n');
        this.csvData = rows.map(row => row.split(',')).filter(row => row.some(cell => cell.trim() !== ''));   
        if (this.csvData[this.csvData.length - 1].length === 1 && this.csvData[this.csvData.length - 1][0] === '') {
          this.csvData.pop();
        }
        this.validationCheck()
    }

    private async validationCheck() {
        this.mappedResult = this.mapToDesiredFormat(this.csvData);
        this.isSpinnerLoading = true;
            await this.$apiClient.doRequest('get', `/admin/chemicals/chemicalsList`).then((res) => {
            this.selectedChemicals = res;
            const errorIds: string[] = [];
            this.mappedResult.forEach((resultChemical) => {
                    const resultChemicalId = String(resultChemical.chemical_id); 
                    const resultChemicalName = String(resultChemical.chemical_name); 
                    const selectedChemical = this.selectedChemicals.find((chem) => chem.display_name === resultChemicalName || String(chem.id) === resultChemicalId);
                    if (selectedChemical) {
                        const selectedChemicalId = String(selectedChemical.id); 
                        const selectedChemicalName = String(selectedChemical.display_name);
                        if (selectedChemicalId === resultChemicalId) {
                            this.isAlert = true;
                            if(resultChemicalName === ''){
                                resultChemical.chemical_name = selectedChemical.display_name;
                                resultChemical.chemicalIdNameMismatch = false; 
                                resultChemical.chemicalNameErrorFlag = false;

                            } else if(resultChemicalName !== selectedChemicalName){
                                resultChemical.chemicalIdNameMismatch = true; 
                                resultChemical.chemicalNameErrorFlag = false;
                            } else {
                                resultChemical.chemicalIdNameMismatch = false; 
                                resultChemical.chemicalNameErrorFlag = false;
                            }
                        } else if(selectedChemicalName === resultChemicalName){
                            if(resultChemicalId === ''){
                                resultChemical.chemical_id = selectedChemical.id;
                                resultChemical.chemicalIdNameMismatch = false;
                                resultChemical.chemicalEmptyFlag = false;
                            } else if(resultChemicalId !== selectedChemicalId){
                                resultChemical.chemicalIdNameMismatch = true;
                            }else {
                                resultChemical.chemicalIdNameMismatch = false;
                                resultChemical.chemicalEmptyFlag = false;
                            }
                        }else {
                            if(resultChemicalId===''||resultChemicalName===''){
                            resultChemical.chemicalIdNameMismatch = false;
                            }else{
                                resultChemical.chemicalIdNameMismatch = true;
                                errorIds.push(resultChemicalId);
                            }
                        }
                    }else if((resultChemicalId !== '' && resultChemicalId) || (resultChemicalName !== '' && resultChemicalName)){
                        resultChemical.chemicalIdNameMismatch = true;
                        resultChemical.chemicalErrorFlag = true;
                        errorIds.push(resultChemicalId);
                    }
                });
            });
            
            if(this.warehouseId!=""){
               await this.$apiClient.getRequest(`/admin/warehouses/${this.warehouseId}`).then((res) => {
                    this.selectedChemicals = toCamel(res.data.chemicals) as ChemicalStocks[];
                    const matchedChemicals = this.mappedResult
                    .filter(resultChemical => this.selectedChemicals.some(chem => chem.id === resultChemical.chemical_id));

                    this.matchedChemicalDetailsArray = matchedChemicals.map(resultChemical => ({
                        id: resultChemical.chemical_id,
                        unit_name: resultChemical.unit_name,
                        display_name: resultChemical.chemical_name,
                    }));

                    const matchedChemicalst: any[] = [];
                    this.mappedResult.forEach((resultChemical) => {
                        const selectedChem = this.selectedChemicals.find(chem => chem.id === resultChemical.chemical_id);
                        if (selectedChem) {
                            if(resultChemical.unit_name === ''){
                                resultChemical.chemicalWeightUnitEmptyFlag = true;
                                resultChemical.chemicalWeightUnitErrorFlag = false;
                            } else if (selectedChem.unit_name !== resultChemical.unit_name) {
                                this.isAlert = true;
                                resultChemical.chemicalWeightUnitErrorFlag = false;
                                resultChemical.chemicalWeightUnitMismatchErrorFlag = true;
                                resultChemical.chemicalWeightUnitEmptyFlag = false;
                                resultChemical.master_unit_name = selectedChem.unit_name;
                            } else{
                                resultChemical.chemicalWeightUnitEmptyFlag = false;
                                resultChemical.chemicalWeightUnitErrorFlag = false;
                                resultChemical.unit_name = selectedChem.unit_name;
                            }
                        }
                    });

                    const unmatchedChemicals: { id: string | number; unit_name: string; display_name: string; }[] = this.mappedResult
                        .filter(resultChemical => !this.selectedChemicals.some(chem => chem.id === resultChemical.chemical_id))
                        .reduce((acc, resultChemical) => {
                            if (!acc.some(chem => chem.id === Number(resultChemical.chemical_id))) {
                                acc.push({
                                    id: Number(resultChemical.chemical_id),
                                    unit_name: resultChemical.unit_name,
                                    display_name: resultChemical.chemical_name,
                            });
                        }
                        return acc;
                    }, [] as { id: string | number; unit_name: string; display_name: string; }[]);
                    this.unmatchedChemicalDetailsArray = unmatchedChemicals;
                    this.isSpinnerLoading=false
                });
                }else{
                    this.isSpinnerLoading=false
                }
    }
    
    private mapToDesiredFormat(data: string[][]): MappedDataStock[] {
        const mappedData: MappedDataStock[] = [];
        const isValidDate = (dateString: string): boolean => {
            const datePattern = /^(\d{4}[-/]\d{1,2}[-/]\d{1,2}|\d{8})$/;
            if (!datePattern.test(dateString.trim())) return false;
    
            let year, month, day;
            if (dateString.includes('-') || dateString.includes('/')) {
                const parts = dateString.split(/[-/]/);
                year = parseInt(parts[0], 10);
                month = parseInt(parts[1], 10);
                day = parseInt(parts[2], 10);
            } else {
                year = parseInt(dateString.slice(0, 4), 10);
                month = parseInt(dateString.slice(4, 6), 10);
                day = parseInt(dateString.slice(6, 8), 10);
            }
    
            const dateObj = new Date(year, month - 1, day);
            return (
                dateObj.getFullYear() === year &&
                dateObj.getMonth() === month - 1 &&
                dateObj.getDate() === day
            );
        };
        for (const row of data.slice(1)) {
            const [chemicalId, pesticideName, purchaseDate, contentAmount, quantity, unit, amount] = row;
        
            // Call the halfWidthConvertion function for each element in the row
            const convertedRow = row.map(item => this.halfWidthConvertion(item));
        
            const [convertedChemicalId, convertedPesticideName, convertedPurchaseDate, convertedContentAmountInitial, convertedQuantityInitial, convertedUnit, convertedAmountInitial] = convertedRow;
        
            const convertedContentAmount = convertedContentAmountInitial.replace(/^0+(?=\d)/, '');
            const convertedQuantity = (parseFloat(convertedQuantityInitial) < 1 && parseFloat(convertedQuantityInitial) > 0)
            ? ""
            : convertedQuantityInitial;
        
            const convertedAmount = (parseFloat(convertedAmountInitial) < 1 && parseFloat(convertedAmountInitial) > 0)
            ? ""
            : convertedAmountInitial;
            const datePattern = /^(\d{4}[-/]\d{1,2}[-/]\d{1,2}|\d{8})$/;
            const chemicalEmptyFlag = convertedChemicalId.trim() === '';
            const chemicalErrorFlag = chemicalEmptyFlag ? false : !/^\d+$/.test(convertedChemicalId);
            const chemicalNameErrorFlag: boolean = convertedPesticideName.trim() === '';
            const chemicalDateEmptyFlag = convertedPurchaseDate.trim() === '';
            const chemicalDateErrorFlag: boolean = chemicalDateEmptyFlag ? false : !isValidDate(convertedPurchaseDate.trim());
            const chemicalCapacityEmptyFlag = convertedContentAmount.trim() === '';
            const chemicalCapacityErrorFlag: boolean = chemicalCapacityEmptyFlag ? false : !/^(?!.*\.\d{3,})\d{1,7}(\.\d{1,2})?$/.test(convertedContentAmount);
            const chemicalQuanityEmptyFlag = convertedQuantity.trim() === '';
            const chemicalQuanityErrorFlag = chemicalQuanityEmptyFlag ? false : !/^\d{1,7}(\.\d+)?$/.test(convertedQuantity);
            const chemicalQuanityDecimalFlag = (convertedQuantity === '0') ? false : (chemicalQuanityEmptyFlag ? false : /^\d{1,7}\.\d+$/.test(convertedQuantity));
            const chemicalAmountEmptyFlag = convertedAmount.trim() === ''; 
            const chemicalAmountErrorFlag = chemicalAmountEmptyFlag ? false : !/^\d{1,7}(\.\d+)?$/.test(convertedAmount.trim());
            const chemicalAmountDecimalFlag = chemicalAmountEmptyFlag ? false : /^\d{1,7}\.\d+$/.test(convertedAmount.trim());
            const chemicalWeightUnitEmptyFlag = convertedUnit.trim() === ''; 
            const chemicalWeightUnitErrorFlag = chemicalWeightUnitEmptyFlag ? false : !this.chemicalUnits?.map(u => u.name.toLowerCase()).includes(convertedUnit.trim().toLowerCase());
            const mappedEntry: MappedDataStock = {
                chemical_id: /^\d+$/.test(convertedChemicalId) ? parseInt(convertedChemicalId, 10) : convertedChemicalId,
                chemical_name: convertedPesticideName,
                amount: chemicalAmountDecimalFlag ? "" :parseInt(convertedAmount,10),
                inner_capacity:chemicalCapacityErrorFlag ? "": convertedContentAmount,
                purchase_date :chemicalDateErrorFlag ?"Invalid Date": moment(convertedPurchaseDate, "YYYYMMDD").format("YYYY-MM-DD"),
                quantity: (chemicalQuanityDecimalFlag || chemicalQuanityErrorFlag || chemicalQuanityEmptyFlag) ? "":parseInt(convertedQuantity,10),
                unit_name: convertedUnit,
                chemicalEmptyFlag: chemicalEmptyFlag,
                chemicalErrorFlag: chemicalErrorFlag,
                chemicalNameErrorFlag: chemicalNameErrorFlag,
                chemicalDateEmptyFlag:chemicalDateEmptyFlag,
                chemicalDateErrorFlag: chemicalDateErrorFlag,
                chemicalCapacityEmptyFlag: chemicalCapacityEmptyFlag,
                chemicalCapacityErrorFlag: chemicalCapacityErrorFlag,
                chemicalWeightUnitEmptyFlag: chemicalWeightUnitEmptyFlag,
                chemicalWeightUnitErrorFlag:chemicalWeightUnitErrorFlag,
                chemicalQuanityErrorFlag: chemicalQuanityErrorFlag,
                chemicalQuanityEmptyFlag : chemicalQuanityEmptyFlag,
                chemicalAmountErrorFlag: chemicalAmountErrorFlag,
                chemicalAmountEmptyflag: (chemicalAmountEmptyFlag||chemicalAmountDecimalFlag),
                chemicalWeightUnitMismatchErrorFlag:false,
                chemicalIdNameMismatch: false,
                chemicalNameNoDataFlag:false,
                master_unit_name:null,
                chemicalQuanityDecimalFlag:chemicalQuanityDecimalFlag
            };
            mappedData.push(mappedEntry);
        }        
        return mappedData;
    }

    private onchangeValidate(index:number){
        const datePattern = /^(\d{4}[-/]\d{1,2}[-/]\d{1,2}|\d{8})$/;
        const mappedData: MappedDataStock[] = [];
    
        this.mappedResult.forEach((item, i )=> {
            if (i !== index) {
                mappedData.push({ ...item, chemicalErrorFlag: false });
                return;
            }
            const convertedChemicalId = item.chemical_id ? item.chemical_id.toString() : '';
            const convertedPesticideName = item.chemical_name ? item.chemical_name.toString() : '';
            const convertedPurchaseDate = item.purchase_date ? item.purchase_date.toString() : '';
            const convertedContentAmount = item.inner_capacity ? item.inner_capacity.toString() : '';
            const convertedQuantity = item.quantity ? item.quantity.toString() : '';
            const convertedAmount = item.amount ? item.amount.toString() : '';
            const convertedUnit = item.unit_name ? item.unit_name.toString() : '';
    
            const chemicalEmptyFlag = convertedChemicalId.trim() === '';
            const chemicalErrorFlag = chemicalEmptyFlag ? false : !/^\d+$/.test(convertedChemicalId);
            const chemicalNameErrorFlag: boolean = convertedPesticideName.trim() === '';
            const chemicalDateEmptyFlag = convertedPurchaseDate.trim() === '';
            const chemicalDateErrorFlag: boolean = chemicalDateEmptyFlag ? false : !datePattern.test(convertedPurchaseDate.trim());
            const chemicalCapacityEmptyFlag = convertedContentAmount.trim() === '';
            const chemicalCapacityErrorFlag: boolean = chemicalCapacityEmptyFlag ? false : !/^(?!.*\.\d{3,})\d{1,7}(\.\d{1,2})?$/.test(convertedContentAmount);
            const chemicalQuanityEmptyFlag = convertedQuantity.trim() === '';
            const chemicalQuanityErrorFlag = chemicalQuanityEmptyFlag ? false : !/^\d{1,7}(\.\d+)?$/.test(convertedQuantity.trim());
            const chemicalAmountEmptyFlag = convertedAmount.trim() === ''; 
            const chemicalAmountErrorFlag = chemicalAmountEmptyFlag ? false : !/^\d{1,7}(\.\d+)?$/.test(convertedAmount.trim());
            const chemicalWeightUnitEmptyFlag = convertedUnit.trim() === ''; 
            const chemicalWeightUnitErrorFlag = chemicalWeightUnitEmptyFlag ? false : !this.chemicalUnits?.map(u => u.name.toLowerCase()).includes(convertedUnit.trim().toLowerCase());
            const mappedEntry: MappedDataStock = {
                chemical_id: /^\d+$/.test(convertedChemicalId) ? parseInt(convertedChemicalId, 10) : convertedChemicalId,
                chemical_name: convertedPesticideName,
                amount: convertedAmount ? parseInt(convertedAmount, 10) : "",
                inner_capacity: convertedContentAmount ? convertedContentAmount : "",
                purchase_date : moment(convertedPurchaseDate, "YYYYMMDD").format("YYYY-MM-DD"),
                quantity: convertedQuantity ? parseInt(convertedQuantity, 10) : "",
                unit_name: convertedUnit,
                chemicalEmptyFlag: chemicalEmptyFlag,
                chemicalErrorFlag: chemicalErrorFlag,
                chemicalNameErrorFlag: chemicalNameErrorFlag,
                chemicalDateEmptyFlag: chemicalDateEmptyFlag,
                chemicalDateErrorFlag: chemicalDateErrorFlag,
                chemicalCapacityEmptyFlag: chemicalCapacityEmptyFlag,
                chemicalCapacityErrorFlag: chemicalCapacityErrorFlag,
                chemicalWeightUnitEmptyFlag: chemicalWeightUnitEmptyFlag,
                chemicalWeightUnitErrorFlag:chemicalWeightUnitErrorFlag,
                chemicalQuanityEmptyFlag: chemicalQuanityEmptyFlag,
                chemicalQuanityErrorFlag: chemicalQuanityErrorFlag,
                chemicalAmountErrorFlag: chemicalAmountErrorFlag,
                chemicalAmountEmptyflag: chemicalAmountEmptyFlag,
                chemicalIdNameMismatch: false,
                chemicalWeightUnitMismatchErrorFlag:false,
                chemicalNameNoDataFlag:false,
                master_unit_name:null,
                chemicalQuanityDecimalFlag:false
            };
            mappedData.push(mappedEntry);
        });
        this.mappedResult = mappedData;    
    }

    private async onChangeChemicalNameValidation(index:number){
        this.$apiClient.doRequest('get', `/admin/chemicals/chemicalsList`).then((res) => {
            this.selectedChemicals = res;
            const errorIds: string[] = [];
            this.mappedResult.forEach((resultChemical,i) => {
            if (i !== index) return;
            const resultChemicalName = String(resultChemical.chemical_name);
            const selectedChemical = this.selectedChemicals.find((chem) => String(chem.display_name) === resultChemicalName);
            if(selectedChemical){
                const selectedChemicalName = String(selectedChemical.display_name);
                if (selectedChemicalName === resultChemicalName) {
                    this.isAlert = true;
                    resultChemical.chemicalIdNameMismatch = false;
                    resultChemical.chemicalErrorFlag = false;
                    resultChemical.chemicalNameErrorFlag = false;
                    resultChemical.chemicalEmptyFlag = false;
                    resultChemical.chemical_id = selectedChemical.id;
                } else {
                    resultChemical.chemicalIdNameMismatch = true;
                    resultChemical.chemicalEmptyFlag = false;
                    resultChemical.chemicalErrorFlag = false;
                    errorIds.push(resultChemicalName);
                }
                }else if(resultChemical.chemical_name === ''){
                    resultChemical.chemicalNameErrorFlag = true;
                    resultChemical.chemicalIdNameMismatch = false;
                }else{
                    resultChemical.chemicalIdNameMismatch = true;
                    resultChemical.chemicalEmptyFlag = false;
                    resultChemical.chemicalErrorFlag = false;
                    resultChemical.chemicalNameErrorFlag = false;
                    resultChemical.chemicalNameNoDataFlag = false;
                    errorIds.push(resultChemicalName);
                }
            });
        });
        if(this.warehouseId!=""){
            await this.$apiClient.getRequest(`/admin/warehouses/${this.warehouseId}`).then((res) => {
                 this.selectedChemicals = toCamel(res.data.chemicals) as ChemicalStocks[];
                 const matchedChemicals = this.mappedResult
                        .filter(resultChemical => this.selectedChemicals.some(chem => chem.id === resultChemical.chemical_id));
                 this.matchedChemicalDetailsArray = matchedChemicals.map(resultChemical => ({
                    id: resultChemical.chemical_id,
                    unit_name: resultChemical.unit_name,
                    display_name: resultChemical.chemical_name,
                }));
    
                const matchedChemicalst: any[] = [];
                this.mappedResult.forEach((resultChemical) => {
                    const selectedChem = this.selectedChemicals.find(chem => chem.display_name === resultChemical.chemical_name);
                    if (selectedChem) {
                        if(resultChemical.unit_name === ''){
                            resultChemical.chemicalWeightUnitEmptyFlag = true;
                            resultChemical.chemicalWeightUnitErrorFlag = false;
                        } else if (selectedChem.unit_name !== resultChemical.unit_name) {
                            this.isAlert = true;
                            resultChemical.chemicalWeightUnitErrorFlag = false;
                            resultChemical.chemicalWeightUnitMismatchErrorFlag = true;
                            resultChemical.chemicalWeightUnitEmptyFlag = false;
                            resultChemical.master_unit_name = selectedChem.unit_name;
                        } else{
                            resultChemical.chemicalWeightUnitErrorFlag = false;
                            resultChemical.chemicalWeightUnitEmptyFlag = false;
                        }
                    }
                });
    
                const unmatchedChemicals: { id: string | number; unit_name: string; display_name: string; }[] = this.mappedResult
                .filter(resultChemical => !this.selectedChemicals.some(chem => chem.id === resultChemical.chemical_id))
                .reduce((acc, resultChemical) => {
                    if (!acc.some(chem => chem.id === Number(resultChemical.chemical_id))) {
                        acc.push({
                            id: Number(resultChemical.chemical_id),
                            unit_name: resultChemical.unit_name,
                            display_name: resultChemical.chemical_name,
                    });
                }
                return acc;
               }, [] as { id: string | number; unit_name: string; display_name: string; }[]);
    
                this.unmatchedChemicalDetailsArray = unmatchedChemicals;
                this.isSpinnerLoading=false
             });
             }else{
                 this.isSpinnerLoading=false
             }
       }
    
    private halfWidthConvertion(inputString: string): string {
        return inputString
            .split('')
            .map(char => {
                const code = char.charCodeAt(0);
                if (code >= 65281 && code <= 65374) {
                    return String.fromCharCode(code - 65248);
                }
                return char;
            })
        .join('');
    }

    private deletechemicals(index: number): void {
        this.mappedResult.splice(index, 1);
        this.unmatchedChemicalDetailsArray.splice(index, 1);
    }

    private onChangeChemicalUnits(index: number){
        this.onchangeValidate(index);
        this.onChangeChemicalIdValidation(index);
    }

    private onChangeChemicalNames(index: number){
        this.onchangeValidate(index);
        this.onChangeChemicalNameValidation(index);
    }

    private onChangeValidationCheck(index: number){
        this.onchangeValidate(index);
        this.onChangeChemicalNameValidation(index);
    }

    private limitChemicalIdLength(index: number) {
        const chemicalId = this.mappedResult[index].chemical_id;
        if (typeof chemicalId === 'string' && chemicalId.length > 6) {
            this.mappedResult[index].chemical_id = chemicalId.slice(0, 6);
        }
    }

    private async onChangeChemicalIdValidation(index:number){
        this.$apiClient.doRequest('get', `/admin/chemicals/chemicalsList`).then((res) => {
        this.selectedChemicals = res;
        const errorIds: string[] = [];
        this.mappedResult.forEach((resultChemical,i) => {
        if (i !== index) return;
        const resultChemicalId = String(resultChemical.chemical_id);
        const selectedChemical = this.selectedChemicals.find((chem) => String(chem.id) === resultChemicalId);
        if (selectedChemical) {
            const selectedChemicalId = String(selectedChemical.id);
            if (selectedChemicalId === resultChemicalId) {
                this.isAlert = true;
                resultChemical.chemicalIdNameMismatch = false;
                resultChemical.chemicalErrorFlag = false;
                resultChemical.chemicalNameErrorFlag = false;
                resultChemical.chemicalEmptyFlag = false;
                resultChemical.chemical_name = selectedChemical.display_name;
            } else {
                resultChemical.chemicalIdNameMismatch = true;
                resultChemical.chemicalEmptyFlag = false;
                resultChemical.chemicalErrorFlag = false;
                errorIds.push(resultChemicalId);
            }
            } else if(resultChemical.chemical_id === ''){
                resultChemical.chemicalEmptyFlag = true;
                resultChemical.chemicalIdNameMismatch = false;
            }else{
                resultChemical.chemicalIdNameMismatch = true;
                resultChemical.chemicalEmptyFlag = false;
                resultChemical.chemicalErrorFlag = false;
                resultChemical.chemicalNameErrorFlag = false;
                resultChemical.chemicalNameNoDataFlag = false;
                errorIds.push(resultChemicalId);
            }
      });
    });
    if(this.warehouseId!=""){
        await this.$apiClient.getRequest(`/admin/warehouses/${this.warehouseId}`).then((res) => {
             this.selectedChemicals = toCamel(res.data.chemicals) as ChemicalStocks[];
             const matchedChemicals = this.mappedResult
                    .filter(resultChemical => this.selectedChemicals.some(chem => chem.id === resultChemical.chemical_id));
             this.matchedChemicalDetailsArray = matchedChemicals.map(resultChemical => ({
                id: resultChemical.chemical_id,
                unit_name: resultChemical.unit_name,
                display_name: resultChemical.chemical_name,
            }));

            const matchedChemicalst: any[] = [];
            this.mappedResult.forEach((resultChemical) => {
                const selectedChem = this.selectedChemicals.find(chem => chem.id === resultChemical.chemical_id);
                if (selectedChem) {
                    if(resultChemical.unit_name === ''){
                        resultChemical.chemicalWeightUnitEmptyFlag = true;
                        resultChemical.chemicalWeightUnitErrorFlag = false;
                    } else if (selectedChem.unit_name !== resultChemical.unit_name) {
                        this.isAlert = true;
                        resultChemical.chemicalWeightUnitErrorFlag = false;
                        resultChemical.chemicalWeightUnitMismatchErrorFlag = true;
                        resultChemical.chemicalWeightUnitEmptyFlag = false;
                        resultChemical.master_unit_name = selectedChem.unit_name;
                    } else{
                        resultChemical.chemicalWeightUnitErrorFlag = false;
                        resultChemical.chemicalWeightUnitEmptyFlag = false;
                    }
                }
            });

            const unmatchedChemicals: { id: string | number; unit_name: string; display_name: string; }[] = this.mappedResult
            .filter(resultChemical => !this.selectedChemicals.some(chem => chem.id === resultChemical.chemical_id))
            .reduce((acc, resultChemical) => {
                if (!acc.some(chem => chem.id === Number(resultChemical.chemical_id))) {
                    acc.push({
                        id: Number(resultChemical.chemical_id),
                        unit_name: resultChemical.unit_name,
                        display_name: resultChemical.chemical_name,
                });
            }
            return acc;
           }, [] as { id: string | number; unit_name: string; display_name: string; }[]);

            this.unmatchedChemicalDetailsArray = unmatchedChemicals;
            this.isSpinnerLoading=false
         });
         }else{
             this.isSpinnerLoading=false
         }
     }

    getChemicalUnits() {
        this.$apiClient.doRequest('get','/unit_conversion/chemicals').then((res) => {
        this.chemicalUnits = res.weight_units
        })
    }
 }
